export default {
  init() {
    const togglerItemWrap = document.querySelector('.js-toggler-wrap');
    const togglerChilds = document.querySelectorAll('[data-price]');
    const togglerItem = document.querySelector('.js-toggler-button');
    if (togglerItem) {
      togglerItem.addEventListener('click', event => {
        if (event.target.checked) {
          togglerItemWrap.classList.remove('pricing__toggler--active');
          togglerChilds.forEach(item => {
            if (item.dataset.annually) {
              item.textContent = item.dataset.annually;
            }
          });
        } else {
          togglerItemWrap.classList.add('pricing__toggler--active');
          togglerChilds.forEach(item => {
            if (item.dataset.month) {
              item.textContent = item.dataset.month;
            }
          });
        }
      });
    }
  }
};
